import { Tabs, Tab } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { isPaidSearchPagesAvailable } from "app/pages/keyword-research/utils/permissions";
import { useSelectedPageTab } from "app/custom-hooks/useSelectedPageTab";
import { TabListStyled } from "app/components/keyword-research/landing-pages/styledComponents";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { WebsiteKeywordsPage2 } from "./WebsiteKeywordsPage2";

export const WebsiteKeywordsPage2Container = () => {
    const { selectedPageTabIndex, setSelectedPageTabIndex } = useSelectedPageTab(EKeywordTabs);
    const onPageTabSelect = (index: EKeywordTabs) => {
        if (index !== selectedPageTabIndex) {
            const selectedTabKey = EKeywordTabs[index];
            setSelectedPageTabIndex(index);
            void proNavigator.updateParams({ selectedPageTab: selectedTabKey });
            allTrackers.dispatchTrackEvent("Tab", "click", `Change page tab/${selectedTabKey}`);
        }
    };

    return (
        <Tabs
            onSelect={onPageTabSelect}
            selectedIndex={selectedPageTabIndex}
        >
            <TabListStyled size={"lg"}>
                <Tab
                    id={EKeywordTabs.Total}
                    data-automation-item="total"
                >
                    {translate("search.website.keywords.tab.total")}
                </Tab>
                <Tab
                    id={EKeywordTabs.Organic}
                    data-automation-item="organic"
                >
                    {translate("search.website.keywords.tab.organic")}
                </Tab>
                {isPaidSearchPagesAvailable() ? (
                    <Tab
                        id={EKeywordTabs.Paid}
                        data-automation-item="paid"
                    >
                        {translate("search.website.keywords.tab.paid")}
                    </Tab>
                ) : null}
            </TabListStyled>
            <WebsiteKeywordsPage2 />
        </Tabs>
    );
};
